export var button = {
    height: '52px',
    fontSize: '16px',
    backgroundColor: '#0c59f2',
    borderBottomColor: 'rgb(12, 89, 241)',
    borderBottomLeftRadius: '3px',
    borderBottomRightRadius: '3px',
    borderBottomStyle: 'solid',
    borderBottomWidth: '2px',
    borderImageOutset: '0px',
    borderImageRepeat: 'stretch',
    borderImageSlice: '100%',
    borderImageSource: 'none',
    borderImageWidth: 1,
    borderLeftColor: 'rgb(12, 89, 241)',
    borderLeftStyle: 'solid',
    borderLeftWidth: '2px',
    borderRightColor: 'rgb(12, 89, 241)',
    borderRightStyle: 'solid',
    borderRightWidth: '2px',
    borderTopColor: 'rgb(12, 89, 241)',
    borderTopLeftRadius: '3px',
    borderTopRightRadius: '3px',
    borderTopStyle: 'solid',
    borderTopWidth: '2px',
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/@trustpilot/ecommscript-integrationappauth/dist/Styles/common.js
// module id = 236
// module chunks = 0